import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import { useForm } from '@inertiajs/vue3';
    import { UserCompany } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserCompanyForm from './UserCompanyForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditUserCompany',
  props: {
    userCompany: {},
    open: { type: Boolean },
    hideTrigger: { type: Boolean },
    afterSuccess: { type: Function }
  },
  emits: ["finish", "success", "update:open"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const handleSuccess = () => {
        emit('success');
    };

    const dialogFormBindings = computed(() => {
        if (!props.hideTrigger) {
            return {};
        }

        return {
            open: props.open,
            hideTrigger: true,
        };
    });

    const handleUpdateOpen = (value: boolean) => {
        if (props.hideTrigger) {
            emit('update:open', value);
        }
    };

    const form = useForm({
        company_id: props.userCompany.id,
        user_ids: [
            ...props.userCompany.employee_group_ids,
            ...props.userCompany.employee_users.map((user) => user.id.toString()),
        ],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, _mergeProps(dialogFormBindings.value, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.user-companies.update'),
    "query-key": [_unref(QueryKey).USER_COMPANIES],
    title: "companies.user_companies_edit_title",
    "success-message": "companies.user_companies_edit_success",
    "error-message": "companies.user_companies_edit_error",
    "after-success": _ctx.afterSuccess,
    onSuccess: handleSuccess,
    onFinish: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('finish'))),
    "onUpdate:open": handleUpdateOpen
  }), {
    default: _withCtx(() => [
      _createVNode(UserCompanyForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 16, ["form", "route", "query-key", "after-success"]))
}
}

})